import axios, {
  type AxiosError,
  type AxiosRequestConfig,
  HttpStatusCode,
} from 'axios'
import { toast } from 'sonner'

import { rollbar } from '@/modules/shared/infra/rollbar.config'
import { env } from '../infra/env'

const commonOptions: AxiosRequestConfig = {
  baseURL: env.VITE_CATALOGO_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
}

export const catalogoApi = axios.create(commonOptions)

catalogoApi.interceptors.request.use(
  (config) => {
    config.timeout = 60000 * 3 // 3 minutes
    config.timeoutErrorMessage =
      'Tempo de requisição excedido. Por favor, tente novamente.'

    return config
  },
  (error) => {
    rollbar.error(error)
    return Promise.reject(error)
  },
)

catalogoApi.interceptors.response.use(
  (response) => {
    return response
  },
  (error: AxiosError) => {
    const url = error.config?.url || ''
    
    if (error.response?.status === HttpStatusCode.Unauthorized) {
      toast.error('Acesso negado ao catálogo.')
    } else if (error.response?.status === HttpStatusCode.NotFound) {
      // Não mostra toast para endpoints de validação - 404 é esperado quando não há token
      if (!url.includes('/api/token/validate')) {
        toast.error('Recurso não encontrado.')
      }
    } else if (error.response?.status >= HttpStatusCode.InternalServerError) {
      toast.error('Erro interno do servidor de catálogo.')
    }
    return Promise.reject(error)
  },
)